import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lib-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.scss']
})
export class HeatmapComponent implements OnInit {
  @Input() coordinates: Array<any> = [];
  @Input() max = 0;
  @Input() config: {
    width: number,
    height: number
  } = {
    width: 0,
    height: 0
  };

  constructor() {
  }

  ngOnInit(): void {

  }

}
